import React from "react";

/**
 * Renders a calendar icon.
 *
 * @param {string} cls - The class name for the SVG element
 * @return {JSX.Element} The calendar icon SVG element
 */
export const CalendarIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className={cls}
    >
      <path
        d="M18.625 4.01562H17.75V3.14062C17.75 2.90856 17.6578 2.686 17.4937 2.52191C17.3296 2.35781 17.1071 2.26562 16.875 2.26562C16.6429 2.26562 16.4204 2.35781 16.2563 2.52191C16.0922 2.686 16 2.90856 16 3.14062V4.01562H9V3.14062C9 2.90856 8.90781 2.686 8.74372 2.52191C8.57962 2.35781 8.35706 2.26562 8.125 2.26562C7.89294 2.26562 7.67038 2.35781 7.50628 2.52191C7.34219 2.686 7.25 2.90856 7.25 3.14062V4.01562H6.375C5.2151 4.01701 4.10311 4.4784 3.28294 5.29857C2.46277 6.11874 2.00139 7.23073 2 8.39062L2 18.8906C2.00139 20.0505 2.46277 21.1625 3.28294 21.9827C4.10311 22.8029 5.2151 23.2642 6.375 23.2656H18.625C19.7849 23.2642 20.8969 22.8029 21.7171 21.9827C22.5372 21.1625 22.9986 20.0505 23 18.8906V8.39062C22.9986 7.23073 22.5372 6.11874 21.7171 5.29857C20.8969 4.4784 19.7849 4.01701 18.625 4.01562ZM3.75 8.39062C3.75 7.69443 4.02656 7.02675 4.51884 6.53447C5.01113 6.04219 5.67881 5.76562 6.375 5.76562H18.625C19.3212 5.76562 19.9889 6.04219 20.4812 6.53447C20.9734 7.02675 21.25 7.69443 21.25 8.39062V9.26562H3.75V8.39062ZM18.625 21.5156H6.375C5.67881 21.5156 5.01113 21.2391 4.51884 20.7468C4.02656 20.2545 3.75 19.5868 3.75 18.8906V11.0156H21.25V18.8906C21.25 19.5868 20.9734 20.2545 20.4812 20.7468C19.9889 21.2391 19.3212 21.5156 18.625 21.5156Z"
        fill="currentColor"
      />
      <path
        d="M12.5 17.2656C13.3284 17.2656 14 16.5941 14 15.7656C14 14.9372 13.3284 14.2656 12.5 14.2656C11.6716 14.2656 11 14.9372 11 15.7656C11 16.5941 11.6716 17.2656 12.5 17.2656Z"
        fill="currentColor"
      />
      <path
        d="M6.5 17.2656C7.32843 17.2656 8 16.5941 8 15.7656C8 14.9372 7.32843 14.2656 6.5 14.2656C5.67157 14.2656 5 14.9372 5 15.7656C5 16.5941 5.67157 17.2656 6.5 17.2656Z"
        fill="currentColor"
      />
      <path
        d="M17.5 17.2656C18.3284 17.2656 19 16.5941 19 15.7656C19 14.9372 18.3284 14.2656 17.5 14.2656C16.6716 14.2656 16 14.9372 16 15.7656C16 16.5941 16.6716 17.2656 17.5 17.2656Z"
        fill="currentColor"
      />
    </svg>
  );
};
